import React from 'react';
import ActivityTab from 'v2/common/DRM/ActivityTab/ActivityTab';
import CustomTabComponent from 'v2/common/DRM/CustomTab';
import ContactDetailTab from 'v2/pages/ContactsDetails/ContactDetailTab/ContactDetailTab';
import {
  ActivityAssociation,
  DrmPage,
  DjangoListResponse,
  CustomTab,
  ContactTabType,
  Contact,
  DrmEntityBackend,
} from 'v2/models';
import GenericAssociationTab, {
  DRMEntity,
} from 'v2/common/DRM/GenericAssociations/GenericAssociationTab';
import { getContactNameToDisplay } from 'v2/utils/ContactUtils';

interface ContactTabContentProps {
  selectedTab: string;
  customTabs: DjangoListResponse<CustomTab> | undefined;
  TABS: ContactTabType[];
  contact: Contact;
  refetch: () => void;
}

const ContactTabContent = ({
  selectedTab,
  customTabs,
  TABS,
  contact,
  refetch,
}: ContactTabContentProps) => {
  const defaultAssociations: ActivityAssociation[] = [
    ...(contact.primary_associations.data_vendor
      ? [
          {
            table_name: 'DataVendor',
            name: contact.primary_associations.data_vendor.name,
            object_id: contact.primary_associations.data_vendor.id,
            editable: true,
          },
        ]
      : []),
    {
      table_name: 'Contact',
      name: getContactNameToDisplay(contact),
      object_id: contact.id,
    },
  ];

  const renderTab = () => {
    switch (selectedTab) {
      case 'details':
        return <ContactDetailTab contact={contact} refetch={refetch} />;

      case 'associations': {
        const contactEntity: DRMEntity = {
          ...contact,
          name: getContactNameToDisplay(contact),
          type: DrmEntityBackend.CONTACT,
        };

        return (
          <GenericAssociationTab entity={contactEntity} refetch={refetch} />
        );
      }
      case 'activity':
        return (
          <ActivityTab
            relatedTable="Contact"
            relatedObjectId={contact.id}
            defaultAssociations={defaultAssociations}
          />
        );
      default:
        if (!TABS.some((tab) => tab['eventKey'] === selectedTab)) {
          return (
            <CustomTabComponent
              drmPage={DrmPage.CONTACT}
              tab={customTabs?.results.find((tab) => tab.name === selectedTab)}
              entity={contact}
              onUpdate={() => {
                refetch();
              }}
            />
          );
        }
        return null;
    }
  };

  return <div>{renderTab()}</div>;
};

export default ContactTabContent;
